export default {
  getClientDocuments: '/mrx-gateway/mrxassistmemberservice/admin/api/documents',
  changeClientDocument: clientDocumentId => `/mrx-gateway/mrxassistmemberservice/admin/api/document/${clientDocumentId}`,
  addClientDocument: '/mrx-gateway/mrxassistmemberservice/admin/api/document',

  getClientDocumentGroups: clientDocumentId => `/mrx-gateway/mrxassistmemberservice/admin/api/document/group/${clientDocumentId}`,
  addClientDocumentGroup: '/mrx-gateway/mrxassistmemberservice/admin/api/document/group',
  deleteClientDocumentGroup: (clientDocumentId, userGroupId) => `/mrx-gateway/mrxassistmemberservice/admin/api/document/${clientDocumentId}/group/${userGroupId}`
}
